export class User {
    constructor() {
        this.user = null;
        this.scaName = null;
        this.getUser = () => {
            return this.user;
        };
        this.setUser = (user) => {
            this.user = user;
        };
    }
}
